import { Component, EventEmitter, Output, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../core/auth/auth.service';
@Component({ selector: 'app-header', standalone: true, imports: [TranslocoPipe], templateUrl: './header.html' })
export class Header { protected readonly environment = environment; protected readonly auth = inject(AuthService); @Output() menuClick = new EventEmitter<void>(); @Output() settingsClick = new EventEmitter<void>(); }
